export const AvReason = {
    CHANGEMENT_VELO: { label: 'Changement de vélo', value: '24' },
    CHANGEMENT_GARANTIES: { label: 'Changement de garanties', value: '2' },
    MISE_A_JOUR_DECLARATION: { label: 'Mise à jour de déclaration', value: '8' },
} as const;

export const AvReasonArray = Object.values(AvReason);

export const AvReasonKeyValue = {
    CHANGEMENT_VELO: '24',
    CHANGEMENT_GARANTIES: '2',
    MISE_A_JOUR_DECLARATION: '8',
} as const;